import { Slider } from '@mui/material';

type Props = {
  currentMinValue: number;
  currentMaxValue: number;
  minValue: number;
  maxValue: number;
  onChange: (e: Event, values: number | number[]) => void;
};

export const DoubleRangeSlider: React.FC<Props> = ({
  minValue,
  maxValue,
  currentMaxValue,
  currentMinValue,
  onChange,
}) => {
  return (
    <Slider
      step={1}
      value={[currentMinValue, currentMaxValue]}
      onChange={onChange}
      min={minValue}
      max={maxValue}
			className='dark:[&_.MuiSlider-rail]:bg-white-25 [&_.MuiSlider-rail]:bg-black-25'
      sx={{
        '& .MuiSlider-thumb': {
          width: 11,
          height: 11,
        },
        '& .MuiSlider-rail': {
          height: '1px',
        },
        '& .MuiSlider-track': {
          height: '1px',
        },
      }}
    />
  );
};
